import React, { FunctionComponent } from "react"
import { FormControl, Modal, OverlayTrigger, Tooltip } from "react-bootstrap"
import TaskDynamicFormTypes from "../../Types/TaskDynamicFormTypes"
import "./TaskDynamicFormDueDatePicker.css"

interface Props {
    manageParentState: Function
    taskBoiler: TaskDynamicFormTypes
}

const TaskDynamicFormDueDatePicker: FunctionComponent<Props> = (props) => {

    // console.log("TaskDynamicFormDueDatePicker props", props)

    const TaskDynamicFormDueDatePickerToolTip = (text: string) => (
        <Tooltip id={`task-dynamic-form-due-date-picker-tooltip`}>
            {text}
        </Tooltip>
    )

    return (

        <div className="TaskDynamicFormDueDatePickerDueDatePicker">
            <Modal
                id="task-dynamic-form-due-date-picker-modal"
                show={true}
                backdrop="static"
                keyboard={true}
                centered={true}
                size={"sm"}
            >
                <Modal.Header>
                    <div className="TaskDynamicFormDueDatePickerModalHeader">
                        <p>Due Date</p>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="TaskDynamicFormDueDatePickerModalBody">
                        <FormControl
                            onChange={(e) => {
                                const value = e.target.value.length > 0 ? e.target.value : null
                                props.manageParentState(
                                    [
                                        { key: "taskBoiler", value: { ...props.taskBoiler, ...{ DueDateUTC: value } } },
                                        { key: "setDueDate" }

                                    ])
                            }}
                            value={props.taskBoiler.DueDateUTC || ""}
                            type="date"
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="TaskDynamicFormDueDatePickerModalFooter">
                        <OverlayTrigger placement="top" overlay={TaskDynamicFormDueDatePickerToolTip("Go back")}>
                            <div className="TaskDynamicFormDueDatePickerModalFooterBackBtn" onClick={() => props.manageParentState([{ key: "setDueDate" }])}>
                                <span className="material-icons">arrow_back</span>
                            </div>
                        </OverlayTrigger>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default TaskDynamicFormDueDatePicker